// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3YSI3","ranges":"BmiRanges_ranges__1aNMj"};